import { ReactElement } from "react";
import { convertAreaToPx, GridCellPixelValues } from "./GridCellPixelValuesTracker";
import { TileGroupPlaceHolderRenderState } from "./RenderState/common";
import classNames from "classnames";
import styles from "./TileGroup.module.less";

export type TileGroupPlaceholderProps = {
	placeholder: TileGroupPlaceHolderRenderState;
	cellPixelValues: GridCellPixelValues;
};

export const TileGroupPlaceholder = (props: TileGroupPlaceholderProps): ReactElement => {
	const {
		placeholder,
		cellPixelValues
	} = props;

	return (
		<div
			className={
				classNames(
					styles.root,
					styles.root_placeholder
				)
			}
			style={convertAreaToPx(placeholder, cellPixelValues)}
		/>
	);
};
TileGroupPlaceholder.displayName = "TileGroupPlaceholder";
